import React, { Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Helmet } from "react-helmet";
import { Link, useParams } from "react-router-dom";

import { fetchDestinationGuideDetails } from "../../data/destination-guide/destinationGuideDetailsSlice";
import { useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";

const DestinationGuideDetailsDetails = () => {
  const { t } = useTranslation();
  const { destinationUrl } = useParams();
  const isMobile = useMediaQuery("(max-width:767px)");
  const isTablet = useMediaQuery("(max-width:1024px)");

  const dispatch = useDispatch();
  const language = useSelector((state) => state.language.language);

  const { destinationGuideDetails, loading, error } = useSelector(
    (state) => state.destinationGuideDetails
  );

  useEffect(() => {
    dispatch(fetchDestinationGuideDetails({ destinationUrl, language }));
  }, [dispatch, destinationUrl, language]);
  return (
    <>
      <Helmet>
        <title>
          {destinationGuideDetails.pageDetails?.pageMetatagTitle ??
            "destination guide details"}
        </title>
        <link
          rel="canonical"
          href={`https://travco.com/${language}/destination-guide/${destinationUrl}`}
        />

        <meta
          name="description"
          content={destinationGuideDetails.pageDetails?.pageMetatagDescription}
        />
        <meta
          property="og:title"
          content={destinationGuideDetails.pageDetails?.metatagTitleFacebook}
        />
        <meta
          property="og:description"
          content={
            destinationGuideDetails.pageDetails?.metatagDescriptionFacebook
          }
        />
        <meta
          name="twitter:title"
          content={destinationGuideDetails.pageDetails?.metatagTitleTwitter}
        />
        <meta
          name="twitter:description"
          content={
            destinationGuideDetails.pageDetails?.metatagDescriptionTwitter
          }
        />
      </Helmet>{" "}
      <section className="outter">
        <div
          id="rlr_banner_slider"
          className="splide rlr-banner-splide rlr-banner-splide--fullwidth-v2"
        >
          <div className="splide__track rlr-banner-splide__track">
            <ul className="splide__list height-internal-pages">
              <li className="splide__slide height-internal-pages rlr-banner-splide__slide">
                <div className="rlr-banner-splide__image-wrapper height-internal-pages">
                  <div className="overlay-banner"></div>
                  <Suspense fallback={<div>{t("Loading")}...</div>}>
                    {" "}
                    <img
                      src={
                        isMobile
                          ? destinationGuideDetails.pageDetails
                              ?.pageBannerMobile
                          : isTablet
                          ? destinationGuideDetails.pageDetails
                              ?.pageBannerTablet
                          : destinationGuideDetails.pageDetails?.pageBannerPc
                      }
                      alt={destinationGuideDetails.pageDetails?.pageTitle}
                      loading="lazy"
                    />
                  </Suspense>
                </div>
                <article className="rlr-banner-splide__content-wrapper container">
                  <div className="row justify-content-start">
                    <div className="col-xl-9">
                      <div className="rlr-banner-splide__header">
                        <h2
                          className="rlr-banner-splide__slogan rlr-section__title--main"
                          style={{ textShadow: "1px 1px 2px #000" }}
                        >
                          {destinationGuideDetails.pageDetails?.pageTitle}
                        </h2>
                      </div>
                    </div>
                  </div>
                </article>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <div className="container">
        <div className="rlr-search-results-page__breadcrumb-section">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb rlr-breadcrumb__items">
              <li className="breadcrumb-item rlr-breadcrumb__item">
                <Link to="/">{t("Home")} </Link>
              </li>
              <li className="breadcrumb-item rlr-breadcrumb__item">
                <Link to="/destination-Guide">{t("Destinations Guide")} </Link>
              </li>
              <li
                className="breadcrumb-item rlr-breadcrumb__item active"
                aria-current="page"
              >
                {destinationGuideDetails.pageDetails?.pageTitle}
              </li>
            </ol>
          </nav>
          <div className="rlr-icon-text">
            <i className="rlr-icon-font flaticon-phone-receiver-silhouette">
              {" "}
            </i>{" "}
            <Link
              to="tel:(+202) 3854 1010"
              className="rlr-search-results-page__phone"
            >
              {t("Questions")}
              {language == "ar" ? (
                <>
                  ؟ <span style={{ direction: "ltr" }}> (+202) 3854 1010</span>
                </>
              ) : (
                "? (+202) 3854 1010"
              )}{" "}
            </Link>
          </div>
        </div>
      </div>
      <section className="blog-details-section pt-100 pb-70">
        <div className="container">
          <h2
            className="rlr-newsletter__title rlr-section__title--main"
            style={{ fontWeight: "600", marginBottom: "2rem" }}
          >
            {destinationGuideDetails.pageDetails?.pageTitle}{" "}
            {t("Destination Guide")}
          </h2>
          <div className="row  justify-content-between align-items-center ">
            <div className="col-12 d-flex flex-column flex-lg-row-reverse  justify-content-between  py-2 tab-display">
              <img
                alt={destinationGuideDetails.pageDetails?.pageTitle}
                src={destinationGuideDetails.destinationMap}
                id="hp"
                style={{
                  margin: isMobile ? "0 0 30px 0 " : "0 0 15px 15px",
                  maxWidth: "590px",
                  height: "auto",
                  textAlign: "center",
                }}
              />
              <div
                dangerouslySetInnerHTML={{
                  __html: destinationGuideDetails.pageDetails?.pageText,
                }}
              />
            </div>
          </div>

          <hr className=" text-secondary" style={{ margin: "2.5rem 0" }} />
          {destinationGuideDetails.activityWithSight?.length > 0 && (
            <>
              <h2
                className="rlr-newsletter__title rlr-section__title--main"
                style={{ fontWeight: "600", marginBottom: "2rem" }}
              >
                {destinationGuideDetails.pageDetails?.pageTitle}{" "}
                {t("Activities")}
              </h2>
              <div
                className="rlr-secondary-menu-desc"
                data-id="rlr-product-sec-faq"
              >
                <div className="rlr-secondary-menu-desc__details border-0">
                  <div className="accordion rlr-accordion">
                    {destinationGuideDetails.activityWithSight?.map(
                      (activity, index) => (
                        <div
                          className="accordion-item rlr-accordion__item"
                          key={index}
                        >
                          {" "}
                          <div
                            className="accordion-header rlr-accordion__header"
                            id="rlr-faq-collapse-header_13"
                          >
                            <button
                              className="accordion-button rlr-accordion__button collapsed"
                              type="button"
                              data-bs-toggle="collapse"
                              data-bs-target={`#rlr-faq-collapse_${index}`}
                              aria-expanded="false"
                              aria-controls={`rlr-faq-collapse_${index}`}
                            >
                              <span className="rlr-accordion__badge">
                                {index + 1}{" "}
                              </span>{" "}
                              {activity.activity.destinationActivitiesName}
                            </button>
                          </div>{" "}
                          <div
                            id={`rlr-faq-collapse_${index}`}
                            className="accordion-collapse collapse"
                            aria-labelledby={`rlr-faq-collapse-header_${index}`}
                          >
                            <div className="accordion-body rlr-accordion__body">
                              <div
                                dangerouslySetInnerHTML={{
                                  __html:
                                    activity.activity
                                      ?.destinationActivitiesDetails,
                                }}
                              />
                              {activity.sights?.map((item, i) => (
                                <div
                                  key={i}
                                  className="rlr-readmore-desc d-flex flex-column-reverse flex-lg-row justify-content-between align-items-center mb-3"
                                  style={{
                                    borderBottom: "1px solid #ccc",
                                    paddingBottom: "15px",
                                  }}
                                >
                                  <div>
                                    <strong
                                      style={{
                                        color: "#e60000",
                                        fontSize: "25px",
                                        fontFamily: "'Prata', serif",
                                      }}
                                    >
                                      {item.sightName}
                                    </strong>
                                    <br />
                                    <div
                                      dangerouslySetInnerHTML={{
                                        __html: item.sightDetails,
                                      }}
                                    />
                                  </div>
                                  {item.sightPhoto &&
                                  item.sightPhoto !=
                                    `https://cp.travco.com/images/uploads/` ? (
                                    <img
                                      src={item.sightPhoto}
                                      className="ms-3 mb-2 mb-lg-0"
                                      alt={item.sightName}
                                      style={{
                                        width: "250px",
                                        height: "200px",
                                      }}
                                      loading="lazy"
                                    />
                                  ) : (
                                    ""
                                  )}
                                </div>
                              ))}
                            </div>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </section>
    </>
  );
};

export default DestinationGuideDetailsDetails;
